import { render } from "./CustomSearch.vue?vue&type=template&id=390edba0&ts=true"
import script from "./CustomSearch.vue?vue&type=script&lang=ts"
export * from "./CustomSearch.vue?vue&type=script&lang=ts"

import "./CustomSearch.vue?vue&type=style&index=0&id=390edba0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Search/CustomSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "390edba0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('390edba0', __exports__)) {
    api.reload('390edba0', __exports__)
  }
  
  module.hot.accept("./CustomSearch.vue?vue&type=template&id=390edba0&ts=true", () => {
    api.rerender('390edba0', render)
  })

}


export default __exports__